import { Component, OnInit } from '@angular/core';
import { AppConfigurationService } from '../../app-configuration.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  baseImageUrl: string;
  constructor(private appConfigService: AppConfigurationService) {}

  ngOnInit(): void {
    if (this.appConfigService.getURLConfig?.baseImageUrl) {
      this.baseImageUrl = this.appConfigService.getURLConfig.baseImageUrl;
    }
  }
}
